import { Navigation } from "../Navigation";
import * as Style from "./styles";
import * as StyleGlobal from '../../shared/GlobalStyles/styles'
import { useContext, useState } from "react";
import { DarkModeContext } from "../../contexts/darkMode";

export const TreeItem = ({...rest}) => {
    const {countTable, openSidebar, children, colorSvg, coutDelivery, item, padding, selectedTheme} = rest;
    const [isVisible, setIsVisible] = useState(false);
    const {darkModeButton, verifySisteShopIcon} = useContext(DarkModeContext)
    if(item.title && item.isVisible) return <Navigation.ListItemTitle key={item.id} text={item.title} openSidebar={openSidebar}/>
    const theme = colorSvg ?  darkModeButton ? verifySisteShopIcon()  : selectedTheme.backgrounds.blue : darkModeButton ? verifySisteShopIcon() : selectedTheme.backgrounds.blue4 

    return(
        <>
            {
                (item?.isVisible && openSidebar)? (
                    <Navigation.ListItemButton 
                        nameTooltip={item.name}
                        openSidebar={openSidebar}
                        padding={padding}
                        onClick={() => {
                            if(item.link !== undefined && !item.disableLink) item.link();
                            if(children?.length > 0) setIsVisible(!isVisible)
                            }
                        }
                        themeColor={darkModeButton ? '#272a2c' : ''}
                    >
                        <Navigation.ListItemIcon>
                            <item.icon theme={theme}/>
                        </Navigation.ListItemIcon>
                        <Navigation.ListItemText text={item.name} openSidebar={openSidebar}/>
                        {
                            children?.length > 0 && openSidebar &&
                            <>
                                <Navigation.ListItemIcon openSidebar={openSidebar}>
                                    {
        
        
                                        isVisible ? (
                                            <StyleGlobal.IconArrowUp stroke={theme}/>
                                        )
                                        :(
        
                                        <StyleGlobal.IconArrowDown stroke={theme}/>
                                        )
                                    }
                                </Navigation.ListItemIcon>
                                
                            </>
                        }
    
        
                        {
                            item.name === 'Delivery' && 
                            <Style.BoxQtdOrder openSidebar={openSidebar} color={colorSvg ? selectedTheme.backgrounds.blue : selectedTheme.backgrounds.blue4}>
                                <p>{coutDelivery}</p>
                            </Style.BoxQtdOrder>
                        }
                        {
                            item.name === 'Mesas' &&
                            <Style.BoxQtdOrder openSidebar={openSidebar} color={colorSvg ? selectedTheme.backgrounds.blue : selectedTheme.backgrounds.blue4}>
                                <p>{countTable}</p>
                            </Style.BoxQtdOrder>
        
                        }
                    </Navigation.ListItemButton> 
                ):(
                    ( !openSidebar && (children?.length === 0 || !children)) && item?.isVisible &&(
                        <Navigation.ListItemButton 
                            nameTooltip={item.name}
                            openSidebar={openSidebar}
                            padding={padding}
                            onClick={() => {
                                if(item.link !== undefined && !item.disableLink) item.link();
                                }
                            }
                            themeColor={darkModeButton ? '#272a2c' : ''}
                        >
                            <Navigation.ListItemIcon>
                                <item.icon theme={theme}/>
                            </Navigation.ListItemIcon>
                            {
                                item.name === 'Delivery' && 
                                <Style.BoxQtdOrder openSidebar={openSidebar} color={colorSvg ? selectedTheme.backgrounds.blue : selectedTheme.backgrounds.blue4}>
                                    <p>{coutDelivery}</p>
                                </Style.BoxQtdOrder>
                            }
                            {
                                item.name === 'Mesas' &&
                                <Style.BoxQtdOrder openSidebar={openSidebar} color={colorSvg ? selectedTheme.backgrounds.blue : selectedTheme.backgrounds.blue4}>
                                    <p>{countTable}</p>
                                </Style.BoxQtdOrder>
            
                            }
                        </Navigation.ListItemButton>
    
                    )
                )
            }



            {
                (isVisible && openSidebar) && children && children?.map((item, i) =>  
                    <TreeItem
                        {...item}
                        openSidebar={openSidebar}
                        selectedTheme={selectedTheme}
                        colorSvg={colorSvg}
                        key={i} 
                        item={item}
                        coutDelivery={coutDelivery}
                        countTable={countTable}
                        darkModeButton={darkModeButton}
                        padding={'10px 16px 10px 48px'}
                    />
                )
            }


            {
                (!openSidebar) && item?.children && item?.children?.map((item, i) =>  
                    <TreeItem
                        {...item}
                        selectedTheme={selectedTheme}
                        openSidebar={openSidebar}
                        colorSvg={colorSvg}
                        key={i} 
                        item={item}
                        coutDelivery={coutDelivery}
                        countTable={countTable}
                        darkModeButton={darkModeButton}
                        padding={'10px 16px 10px 24px'}
                    />
                )
            }
        </>
    )
}  